import React from 'react'
import ReactStickyNotes from '@react-latest-ui/react-sticky-notes';
import { useState } from 'react';

const StickyNotes = ({ stickyHandlerSave, stickyHandler, openStickyNotes }) =>

(
    <div onKeyDown={(e) => stickyHandlerSave(e)}>
        <div className='background-blur-external' style={{zIndex:'9999'}}>
            <div className='container mt-5'>
                <div className='text-right' style={{ width: '100%' }}>
                    <i className='fa fa-close' onClick={()=>openStickyNotes('close')} style={{ color: 'red', fontSize: '20px', cursor: 'pointer' }}></i>
                </div>
                <ReactStickyNotes
                    onChange={(type, payload, notes) => {
                        stickyHandler(type, payload, notes)

                    }

                    }


                />
            </div>
        </div>
    </div>
)



export default StickyNotes